import $ from 'jquery';

const defaults = {
  wrapper: undefined,
  text: 'p',
  lines: 3,
  multi: false, // if this is to combine and truncate multiple blocks of text, such as <p> tags.
};

function TruncateText(element, options) {
  this.element = element;
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.wrapper = this.settings.wrapper;
  this.text = this.settings.text;
  this.lines = this.settings.lines;
  this.multi = this.settings.multi;
  this.concatText = $.proxy(this.concatText, this);
  this.truncate = $.proxy(this.truncate, this);
  this.init();
}

TruncateText.prototype = {
  init() {
    if (this.multi && this.wrapper) { this.concatText(); }
    this.truncate();
    this.ready();
  },

  concatText() {
    const paragraph = this.$element.find(`${this.wrapper} ${this.text}`);
    paragraph.text().replace(/<br>/gi, ' ');
    let returnText = paragraph.first().text();
    paragraph.text(returnText);
    if (paragraph.length > 1) {
      $(paragraph.not(':first-child')).each((i, element) => {
        const elemPara = $(element).text();
        returnText = returnText.concat(` ${elemPara}`);
      });
    }
    this.$element.find(`${this.wrapper}`).html(returnText).wrapInner('<p>');
  },

  truncate() {
    const selectors = (this.multi) ? `${this.wrapper} ${this.text}` : `${this.text}`;
    const paragraph = this.$element.find(selectors);
    const lineHt = parseInt($(paragraph).css('line-height'), 10);
    const totalHt = lineHt * this.lines;
    let str = paragraph.text();
    while ($(paragraph).height() > totalHt) {
      str = `${str.substring(0, str.lastIndexOf(' '))}...`;
      paragraph.text(str);
    }
  },

  ready() {
    this.$element.addClass('ready');
  },
};

export default TruncateText;



// WEBPACK FOOTER //
// ./TruncateText.js